import personnelEditModel from './personnelEditModel.vue';
import batchDataImport from './batchDataImport.vue';
import personnelEntryModel from './personnelEntryModel.vue';
import { getPersonnelDetailList, personnelDetailsExport } from '../request.js';
import { isCardNo } from '@/utils/validate';
import batchListModel from './batchListModel.vue';
import reducedEmployeeModal from '../../homeManage/personnelDetail/reducedEmployeeModal.vue';
import batchReduceImport from './batchReduceImport.vue';
import { downloadFileFun } from '@/utils/public';
import { mapState } from 'vuex';
export default {
  components: {
    personnelEntryModel,
    batchDataImport,
    reducedEmployeeModal,
    batchReduceImport,
    batchListModel,
    personnelEditModel
  },
  computed: {
    ...mapState({
      tag: state => state.user.accountInfo.tag
    })
  },
  data() {
    const that = this;
    return {
      form: {
        policyStatus: undefined,
        name: '',
        idNumber: '',
        correctEffectiveTime: [],
        remark: ''
      },
      dialogVisible: false,
      importVisible: false,
      importReduceVisible: false,
      reduceVisible: false,
      columns: [{
        slots: {
          title: '工种'
        },
        dataIndex: 'occupation',
        key: 'occupation',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '姓名'
        },
        dataIndex: 'name',
        key: '3',
        align: 'center',
        minWidth: 100
      }, {
        slots: {
          title: '证件类型'
        },
        dataIndex: 'identificationType',
        key: 'identificationType',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '证件号码'
        },
        dataIndex: 'idNumber',
        key: 'idNumber',
        align: 'center',
        width: 180
      }, {
        slots: {
          title: '保单状态'
        },
        scopedSlots: {
          customRender: 'policyStatus'
        },
        dataIndex: 'policyStatus',
        key: 'policyStatus',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '责任起期'
        },
        dataIndex: 'startAt',
        key: 'startAt',
        align: 'center',
        width: 120
      }, {
        slots: {
          title: '责任止期'
        },
        dataIndex: 'endAt',
        key: 'endAt',
        align: 'center',
        width: 120
      }, {
        slots: {
          title: '操作'
        },
        fixed: 'right',
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 250,
        key: '9'
      }],
      data: [],
      editInfo: {},
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${that.$t('共') + total + that.$t('条')}`;
        }
      },
      params: {},
      personEditVisible: false,
      batchListVisible: false,
      loading: false
    };
  },
  created() {
    this.insuranceState = [{
      label: '待生效',
      value: 'PENDING'
    }, {
      label: '保障中',
      value: 'EFFECTIVE'
    }, {
      label: '退保中',
      value: 'CANCEL'
    }, {
      label: '已退保',
      value: 'CANCELED'
    }, {
      label: '已过期',
      value: 'EXPIRED'
    }];
    if (this.$route.params.policyType === 'groupInsurance') {
      this.columns.splice(1, 0, {
        slots: {
          title: '工种类别'
        },
        dataIndex: 'occupationType',
        key: 'occupationType',
        width: 200,
        align: 'center'
      }, {
        slots: {
          title: '保险方案'
        },
        dataIndex: 'insurancePlanName',
        key: 'insurancePlanName',
        width: 150,
        align: 'center'
      }, {
        slots: {
          title: '劳动合同单位（共同被保险人）'
        },
        dataIndex: 'contractCompany',
        key: 'contractCompany',
        width: 180,
        align: 'center'
      }, {
        slots: {
          title: '实际工作单位（派遣单位）'
        },
        dataIndex: 'dispatchCompany',
        key: 'dispatchCompany',
        width: 180,
        align: 'center'
      });
    }
    this.searchFun();
    // console.log(this.columns, 'this.columns');
  },
  methods: {
    onReduce(record) {
      this.params = {
        policyId: this.$route.params.id,
        personnelDetailsId: record.personnelDetailsId
      };
      this.reduceVisible = true;
    },
    cancelImport() {
      this.importVisible = false;
    },
    cancelReduceImport() {
      this.importReduceVisible = false;
    },
    searchFun() {
      this.pagination.current = 1;
      this.getList();
    },
    getList() {
      var _this$form$idNumber;
      if (this.form.idNumber && !isCardNo((_this$form$idNumber = this.form.idNumber) === null || _this$form$idNumber === void 0 ? void 0 : _this$form$idNumber.trim())) {
        this.$message.error(this.$t('身份证号有误'));
        return;
      }
      const {
        name,
        idNumber,
        policyStatus,
        correctEffectiveTime,
        remark
      } = this.form;
      let obj = {
        policyId: this.$route.params.id,
        name: (name === null || name === void 0 ? void 0 : name.trim()) || '',
        idNumber: (idNumber === null || idNumber === void 0 ? void 0 : idNumber.trim()) || '',
        policyStatus,
        remark: (remark === null || remark === void 0 ? void 0 : remark.trim()) || '',
        startAt: (correctEffectiveTime === null || correctEffectiveTime === void 0 ? void 0 : correctEffectiveTime.join('、')) || '',
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      getPersonnelDetailList(obj).then(res => {
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    resetFun() {
      this.$refs.dataform.resetFields();
      this.searchFun();
    },
    personnelEntry() {
      this.dialogVisible = true;
    },
    batchEntry() {
      this.importVisible = true;
    },
    agencyFun() {},
    refreshList() {
      this.current = 1;
      this.getList();
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getList();
    },
    handleReduceOk() {
      this.reduceVisible = false;
      this.getList();
    },
    toBatchList() {
      this.batchListVisible = true;
    },
    handleMenuClick(e) {
      if (e.key === 'add') {
        this.importVisible = true;
      }
      if (e.key === 'reduce') {
        this.importReduceVisible = true;
      }
    },
    editPersonnel(record) {
      this.personEditVisible = true;
      this.editInfo = record;
    },
    personnelExport() {
      const h = this.$createElement;
      const that = this;
      this.loading = true;
      personnelDetailsExport({
        policyId: this.$route.params.id
      }).then(res => {
        if (res.status === 200) {
          this.$confirm({
            icon: () => h("a-icon", {
              "attrs": {
                "type": "check-circle",
                "theme": "twoTone"
              }
            }),
            title: this.$t('导出提示'),
            content: that.$t('导出任务已生成，请稍后查看导出附件'),
            okText: that.$t('确认'),
            cancelText: that.$t('取消'),
            onOk() {}
          });
          let fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[2].split('=')[1].replace(/^\"|\"$/g, '').replace(/utf-8''/, ''));
          downloadFileFun(res.data, 'application/vnd.ms-excel', fileName);
        }
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};